import { pluralize } from "@sellar-io/common";

export const getPriceListDiscountSummary = ({
  counts,
  showVolumeDiscountSets = false,
  separator = " • ",
}: {
  counts: {
    topLevelDiscounts: number | null;
    perItemDiscounts: number | null;
    volumeDiscountsCount: number | null;
    volumeDiscountSetsCount: number | null;
  };
  showVolumeDiscountSets?: boolean;
  separator?: string;
}) => {
  const parts: string[] = [];
  if (counts.topLevelDiscounts !== null) {
    parts.push(
      `${counts.topLevelDiscounts} top level ${pluralize("discount", counts.topLevelDiscounts)}`,
    );
  }
  if (counts.perItemDiscounts !== null) {
    parts.push(
      `${counts.perItemDiscounts} per item ${pluralize("discount", counts.perItemDiscounts)}`,
    );
  }
  if (showVolumeDiscountSets) {
    if (counts.volumeDiscountSetsCount !== null) {
      parts.push(
        `${counts.volumeDiscountSetsCount} volume discount ${pluralize("set", counts.volumeDiscountSetsCount)}`,
      );
    }
  } else if (counts.volumeDiscountsCount !== null) {
    parts.push(
      `${counts.volumeDiscountsCount} volume ${pluralize("discount", counts.volumeDiscountsCount)}`,
    );
  }
  return parts.join(separator);
};
